import React from 'react'
import { Skeleton, Stack } from '@mui/material'
import AiCard from './cardKit/AiCard'

export default function OrderPreviewCardSkeleton() {
    return (
        <AiCard accent="neutral" sx={{ opacity: 0.92 }}>
            <Stack spacing={1.25}>
                <Skeleton variant="text" width="72%" height={28} />
                <Skeleton variant="text" width="48%" height={20} />
                <Stack direction="row" spacing={2} sx={{ pt: 0.5 }}>
                    <Skeleton variant="text" width={88} height={22} />
                    <Skeleton variant="text" width={96} height={22} />
                </Stack>
                <Skeleton variant="rounded" height={36} sx={{ mt: 0.5, maxWidth: 280 }} />
            </Stack>
        </AiCard>
    )
}
